import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "财政",
  "lead": "三分之一的国家未达到《2030 年教育行动框架》中设定的两个财政基准。"
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, HighlightByPalette, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!HighlightByPalette) _missingMdxReference("HighlightByPalette", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_FINANCE"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "如果没有额外的资源，就无法实现雄心勃勃的可持续发展教育目标，尤其那些最落后的国家。"
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "据 GEM 报告（全球教育监测报告）估算，为了实现 2030 年普及基础教育（即学前、小学和中学教育）的目标，低收入和中低收入国家每年需要花费 4610 亿美元。由于税收收入较低，许多国家不太可能充分增加预算，因此，在 2023 年至 2030 年期间，为实现国家目标预计每年将存在 970 亿美元（占总成本的 21％）的财政缺口。低收入国家的平均财政缺口为 260 亿美元（占总成本的 50％），中低收入国家的平均财政缺口为 710 亿美元（占总成本的 17％），相当于同期国内生产总值的 2.3％。"
    }), "\n", _jsx(IndicatorReference, {
      id: "4.5.3",
      children: _jsxs(_components.p, {
        children: ["但是，拥有更多资源并不一定足够；在人均投入金额相同的情况下，各国的教育结果可能也会大相径庭，这取决于投入资金是否得到有效、高效和公平地利用。例如，在具备可用信息的 78 个低收入和中等收入国家中，只有 17 个或五分之一的国家", _jsx(_components.a, {
          href: "https://www.unesco.org/gem-report/en/node/80",
          children: "在财政政策中持续高度重视公平性"
        }), "。这些国家大多是中上收入国家和拉丁美洲国家。"]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["政府、家庭和捐助者是教育经费的三个主要来源。本页将重点介绍前两个。另一页则专门介绍", _jsx(_components.a, {
        href: "https://www.education-progress.org/en/articles/finance-aid",
        children: "aid to education"
      }), "。"]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TOTBYSOURCE"
        })
      }), _jsx(ScrollySection, {
        id: "absolute,0",
        children: _jsx(_components.p, {
          children: "2022 年，在全球教育支出总额为 5.8 万亿美元，其中只有 0.45％ 用于低收入国家，而 64％ 用于高收入国家，尽管这两个群体中的学龄儿童人数大致相等。"
        })
      }), _jsx(ScrollySection, {
        id: "relative,1",
        children: _jsxs(_components.p, {
          children: ["在中等周茹国家，", _jsx(HighlightByPalette, {
            palette: "06",
            index: "1",
            children: "家庭"
          }), "承担了四分之一的教育费用。实际上，中低收入国家的家庭承担的教育费用 (44%) 远高于高收入国家的家庭承担的教育费用 (20%)。"]
        })
      }), _jsx(ScrollySection, {
        id: "relative,2",
        children: _jsxs(_components.p, {
          children: ["尽管", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "捐助者"
          }), "的捐款占低收入国家教育总经费的 12％..."]
        })
      }), _jsx(ScrollySection, {
        id: "absolute,3",
        children: _jsxs(_components.p, {
          children: ["...", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "捐助者的"
          }), "捐款仅占全球总支出的 0.3％，从绝对金额看几乎微不足道。"]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "公共支出",
      children: "公共支出"
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.1",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656",
          children: "2030 年教育行动框架"
        }), " 为各国政府设定了两个关键的财政基准。该框架呼吁各国政府："]
      }), _jsx(_components.p, {
        children: "-至少将国内生产总值的 4％ 至 6％ 分配给教育，和/或\n-至少将公共开支的 15％ 至 20％ 分配给教育。"
      }), _jsx(_components.p, {
        children: "在全球范围内，各国政府在这些规范上并没有偏离太远。政府支出的中位数为 GDP 的 4％ 和公共支出总额的 12.6％。在国内资源创造能力低下但儿童群体庞大的较贫穷国家，政府往往会降低国内生产总值中教育支出所占比例，然而，教育支出在政府总支出中所占比列却较高。"
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.2",
      children: [_jsx(_components.p, {
        children: "在撒哈拉以南非洲地区，政府教育支出占公共支出总额的 15.5％，但仅占 GDP 的 3.5％。相反，在欧洲和北美，教育支出占 GDP 的份额达到了基准 (4.8%)，但在总体支出中，分配给教育的比例却相对较低 (10.9%)。"
      }), _jsx(_components.p, {
        children: "但是，总的来说，在具有最新数据的国家中，大约有三分之一的国家没有达到这两个基准。可以查看这些数据随时间的变化，了解这些年来支出是如何波动的。"
      })]
    }), "\n", _jsx(Figure, {
      id: "GOVVGDP"
    }), "\n", _jsx(_components.p, {
      children: "政府的主要收入来源是税收，即使是那些援助（如赠款）收入占比较高的低收入国家，情况也是如此。总体而言，低收入国家的平均税收收入占 GDP 的 14％，中低收入国家为 18%，中高收入国家为 22%，高收入国家为 33%。例如，即使所有国家在预算中都将教育列为同等优先事项，但是税收和其他国内资源更多的国家在教育支出上也会更多。"
    }), "\n", _jsx(_components.p, {
      children: "话虽如此，在其他特征相似的国家之间，教育支出存在巨大差异，这表明这些关系并不由预设条件决定。一些国家为实现目标会选择增加教育支出。我们应该重点关注那些未能这样做的国家。"
    }), "\n", _jsx(_components.h2, {
      id: "家庭开支",
      children: "家庭开支"
    }), "\n", _jsx(_components.p, {
      children: "家庭花费了大量资金用于子女的教育，且相较于富有国家，贫困国家的家庭在这方面支出更高。"
    }), "\n", _jsx(_components.p, {
      children: "这笔支出可以是学费和其他费用，但也可以用于教育用品和服务，其中有些是必需的（例如教科书），有些则不是（例如私人辅导）。"
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.5.4",
      children: [_jsx(_components.p, {
        children: "如果各国将此类数据标准化，就会有大量证据可以证明家庭对教育总支出的贡献。这可以改变人们对各国教育努力的认知。"
      }), _jsx(_components.p, {
        children: "在低收入国家，由于经济困难，家庭在教育上的支出不足预算的 1％。相比之下，中低收入国家的家庭在教育上的支出中位数 2.9％，未加权平均值为 3.6％，且这些家庭的教育支出占比在各收入水平的国家中最高。中低收入国家较高的教育支出水平表明，家庭面临着弥补公共资金不足的压力。在中上收入国家，家庭预算中用于教育的中位数比例降至 1.5％，未加权平均值为 2.3％。最后，高收入国家的家庭在教育上的支出中位数为 1.3％，未加权平均值为 1.7％。"
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "GOVHH_ABS_REL"
          })
        }), _jsx(ScrollySection, {
          id: "absolute,BGD,FRA",
          children: _jsxs(_components.p, {
            children: ["例如，在 2019 年，", _jsx(_components.strong, {
              children: "孟加拉国"
            }), "是", _jsx(HighlightByIndex, {
              index: "0",
              children: "政府教育支出"
            }), "占 GDP 的百分比最低的国家之一。但是，一旦将", _jsx(HighlightByIndex, {
              index: "1",
              children: "家庭贡献"
            }), "纳入考虑，孟加拉国的全国教育总支出占 GDP 的百分比与", _jsx(_components.strong, {
              children: "法国"
            }), "相近。"]
          })
        }), _jsx(ScrollySection, {
          id: "absolute,IND,BEL",
          children: _jsxs(_components.p, {
            children: [_jsx(_components.strong, {
              children: "印度"
            }), "政府的教育支出在 GDP 中的占比较", _jsx(_components.strong, {
              children: "比利时"
            }), "（蓝色条柱）低约 2.4 个", _jsx(HighlightByIndex, {
              index: "0",
              children: "百分点"
            }), "，但印度的总体支出超过了比利时，因为印度", _jsx(HighlightByIndex, {
              index: "1",
              children: "家庭"
            }), "的教育支出在 GDP 中的占比（红色条柱）较比利时高 2.6 个百分点。"]
          })
        }), _jsx(ScrollySection, {
          id: "relative,NGA,LBN,HTI",
          children: _jsxs(_components.p, {
            children: ["在一些国家，包括", _jsx(_components.strong, {
              children: "尼日利亚"
            }), "、", _jsx(_components.strong, {
              children: "海地"
            }), "和", _jsx(_components.strong, {
              children: "黎巴嫩"
            }), "等，教育总支出中", _jsx(HighlightByIndex, {
              index: "1",
              children: "家庭教育支出的占比"
            }), "超过了 70％。"]
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "结语",
      children: "结语"
    }), "\n", _jsx(_components.p, {
      children: "全球教育监测报告组长期以来一直认为，了解全球教育支出需要对教育资金的三个主要来源进行联合审查：国内公共资金、外部公共资金和私人资金。因此，需要从低收入和中等收入国家获取及时且一致的数据，以说明教育支出和资金来源。"
    }), "\n", _jsx(_components.p, {
      children: "除了增加可用的教育资金外，我们还需要加强资金的公平分配。为了实现全球教育目标 SDG 4，各国和捐助者承担责任并履行承诺至关重要。"
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.unesco.org/gem-report/en/2024efw",
            children: "2024 年教育金融观察 (Education Finance Watch)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/financing-for-equity",
            children: "释放资金，促进教育公平"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://education-profiles.org/",
            children: "促进教育审查概况 (Profiles Enhancing Education Reviews, PEER)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/node/3141",
            children: "新冠疫情对教育复苏援助构成严重威胁"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
